import { render, staticRenderFns } from "./QuestionModule.vue?vue&type=template&id=e9c0e1bc&"
import script from "./QuestionModule.vue?vue&type=script&lang=js&"
export * from "./QuestionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports